/** Excel evaluates a cell starting with any of these. Exported text is operator-entered. */
const FORMULA_LEAD = /^[=+\-@\t\r]/;

/**
 * One CSV cell: neutralised against formula injection, then quoted if it carries the separator,
 * a quote or a line break. Shared so every export in the app escapes the same way — a company
 * typed `=1+1` must reach Excel as text, whichever screen exported it.
 */
export const csvCell = (value: string): string => {
  const safe = FORMULA_LEAD.test(value) ? `'${value}` : value;
  return /["\n\r,]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

/**
 * A whole file from a header and its rows: a BOM, CRLF, and every cell through `csvCell`. Without
 * the first two Excel mangles the accents and the line breaks — a rule every export needs and
 * none should re-derive.
 */
export const buildCsv = (header: string[], rows: string[][]): string =>
  `\uFEFF${[header, ...rows].map((row) => row.map(csvCell).join(',')).join('\r\n')}`;
